import { render, staticRenderFns } from "./modalAttachment.vue?vue&type=template&id=16844fa2&scoped=true&"
import script from "./modalAttachment.vue?vue&type=script&lang=js&"
export * from "./modalAttachment.vue?vue&type=script&lang=js&"
import style0 from "./modalAttachment.vue?vue&type=style&index=0&id=16844fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16844fa2",
  null
  
)

export default component.exports